/* tslint:disable */
/* eslint-disable */

/**
 * 1 = inVorbereitung (in Vorbereitung)
 * 
 * 401130001 = Gutachterangefragt (Gutachter angefragt)
 * 
 * 401130002 = FreigegebenzurBegutachtung (Freigegeben zur Begutachtung)
 * 
 * 2 = Inaktiv (Inaktiv)
 * 
 * 401130003 = inBearbeitung (in Bearbeitung)
 * 
 * 401130005 = Befangenheit (Befangenheit)
 * 
 * 401130004 = Abgegeben (Abgegeben)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode {
 inVorbereitung = 1,
 Gutachterangefragt = 401130001,
 FreigegebenzurBegutachtung = 401130002,
 Inaktiv = 2,
 inBearbeitung = 401130003,
 Befangenheit = 401130005,
 Abgegeben = 401130004
}

marker([
    "Enum.AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.inVorbereitung",
    "Enum.AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.Gutachterangefragt",
    "Enum.AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.FreigegebenzurBegutachtung",
    "Enum.AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.Inaktiv",
    "Enum.AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.inBearbeitung",
    "Enum.AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.Befangenheit",
    "Enum.AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode.Abgegeben"
]);

export namespace AceGutachtenAceGutachtenEnumsAceGutachtenStatuscode
{
    class DataSets
    {
        static AceGutachtenAceGutachtenEnumsAceGutachtenStatuscodeDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("inVorbereitung", 1, "in Vorbereitung"),
            new EnumValue("Gutachterangefragt", 401130001, "Gutachter angefragt"),
            new EnumValue("FreigegebenzurBegutachtung", 401130002, "Freigegeben zur Begutachtung"),
            new EnumValue("Inaktiv", 2, "Inaktiv"),
            new EnumValue("inBearbeitung", 401130003, "in Bearbeitung"),
            new EnumValue("Befangenheit", 401130005, "Befangenheit"),
            new EnumValue("Abgegeben", 401130004, "Abgegeben"),
        )
    }

    export function getAsDataset() {
        return DataSets.AceGutachtenAceGutachtenEnumsAceGutachtenStatuscodeDataSet;
    }
}
